module.exports = __webpack_public_path__ + "static/media/MATH 125.592da324.jpg";